import React, {Component} from 'react';

import ff from './ff';
import bf from './bf';
import ic from './ic';
import cf from './cf';
import ce from './ce';
import cr from './cr';

import cView from './cView';

import c51v1a from './c51v1a';
import i15v1a from './i15v1a';
import i16v1a from './i16v1a';

export default class c10v extends cView {

$cd_stss = { // 親を上書き
  sdld_c10rListsss: {c10r:[]},
  sdld_c10rDtlsss: {c10r:[]},
  s_c10rc31s: '',
  sdld_i130Listsss: {i130:[]},
  s_word: null,
};

$id_stss = {
};

static op_loadSlcList = (pd={
  elm: '',
  key: null, // 歴対応
//  fst: null, // 歴対応
}) => 
  (pd.elm == 'c10r') ?
    super.op_loadSlcList({
      ...pd,
      o_cnd: pd.o_cnd ?? (_dd_datss => { // 歴対応のため、key / fst が指定されている場合の扱いを定義要
        let _cnd = pd.cnd ??
          (pd.key) ?
            cf.c(pd.elm, `_key = ${pd.key}`, false, false) // 履歴対応 dd_cldDefss の cf.c も必ず b_ltt = false を設定 -> call_tree において強制適用？
          : cf.c(pd.elm, `_key = ${global.t?.state.sgc_pageKey}`, false, false); // modified
        return _cnd;
      }),
      od_fmts: pd.od_fmts ?? (_d_dats => {
        let _d = {
          ..._d_dats,
          key: _d_dats.d_flds._key, // 暦対応
          pfx: `${_d_dats.d_flds[`${pd.elm}c31s`]}`, 
          sch: `${_d_dats.d_flds[`${pd.elm}c11s`]} ${_d_dats.d_flds[`${pd.elm}c31s`]}`, 
        };
        return _d;
      }),
    })
  : super.op_loadSlcList(pd)
;

static op_loadDtl = (pd={
  elm: '',
  key: null, // 歴対応
//  fst: null, // 歴対応
}) => 
  (pd.elm == 'c10r') ?
    super.op_loadDtl({
      ...pd,
      o_cnd: pd.o_cnd ?? (_dd_datss => { // 歴対応のため、key / fst が指定されている場合の扱いを定義要
        let _cnd = pd.cnd ??
          (pd.key) ?
            cf.c(pd.elm, `_key = ${pd.key}`, false, false) // 履歴対応 dd_cldDefss の cf.c も必ず b_ltt = false を設定 -> call_tree において強制適用？
//          : (pd.fst) ?
//            cf.c(pd.elm, `_fst = ${pd.fst}`) // modified
//          : cf.c(pd.elm, `_fst = ${global.t?.state.sgc_pageFst}`); // modified
          : cf.c(pd.elm, `_key = ${global.t?.state.sgc_pageKey}`, false, false); // modified
        return _cnd;
      }),
/*
      dd_cldDefss: { // 毎回呼び出すのは、重くないか
        i1z0: { // alias
          elm: 'i1z0',
          o_cnd: _dd_datss => {
            let _cnd = cf.c(`i1z0`, `i1z0b11f = ${_dd_datss.c10r.d_flds._key}`);
            return _cnd;
          },
          dd_rfrss: {
            i10r: {
              elm: 'i10r',
              o_cnd: _d_flds => {
                let _cnd = cf.c(`i10r`, `_fst = ${_d_flds.i1z0b41f}`)
                return _cnd;
              },
            },
            i1zr: {
              elm: 'i1zr',
              o_cnd: _d_flds => {
                let _cnd = cf.c(`i1zr`, `_key = ${_d_flds.i1z0b61k}`, false, false)
                return _cnd;
              },
            },
          },
        },
      },
*/
    })
  : super.op_loadDtl(pd)
;

$clp_loadLists = () =>
  (global.t?.d_viewDefs.class == 'c10v1a') ?
    [
      c10v.op_loadList({
        elm: 'c10r',
        o_cnd: _dd_datss => {
//          let _cnd = cf.c('c10r', `c10rt11i = 20`, false, false) // スタッフに限定
          let _cnd = cf.c('c10r', `c10rt11i = 20 AND c10rc11s <> "999999999999"`, false, false) // スタッフに限定
          return _cnd;
        },
      })
    ]
  : (global.t?.d_viewDefs.class == 'c10v2b') ?
    [
      cf.myRN_savePageStgs({
        sgc_pnlMode: 'dtl',
      }),
      c10v.op_loadDtl({
        elm: 'c10r',
        o_cnd: _dd_datss => {
          let _cnd = cf.c('c10r', `c10rt11i = 10 AND _key = ${global.t?.state.sgcd_cmnStgs.c10r_key}`, false, false) // 団体に限定
          return _cnd;
        },
      })
    ]
  : null
;

$clp_loadDtls = () =>
  (global.t?.d_viewDefs.class == 'c10v1a') ?
    [
      c10v.op_loadDtl({
        elm: 'c10r',
      }),
      c10v.op_loadVsnList({
        elm: 'c10r',
      }),
    ]
  : (global.t?.d_viewDefs.class == 'c10v2b') ?
    [
      global.t?.op_loadListAll()
    ]
  : null
;

$clp_upds = () => 
  bf.i(global.t?.d_viewDefs.class, ['c10v1a']) ? // スタッフ情報
    [
      cr.myCB_call_tree({
        ctr: 'iud',
        state: 'sdld_c10rDtlsss',
        b_vsn: false,
        dd_elmDefss: {
          c10r: {
            b_setPageKey: true,
            od_insDats: pd => {
              let _d = {
                c10rc11s: pd.c10r.d_flds.c10rc11s ?? '',
                c10rc31s: pd.c10r.d_flds.c10rc31s ?? '',
                c10rc01s: pd.c10r.d_flds.c10rc01s ?? '',
                c10rc02s: pd.c10r.d_flds.c10rc02s ?? '',
                c10rt11i: pd.c10r.d_flds.c10rt11i ?? 20, // c10v1a 固有
              };
              return _d;
            },
          },
        },
      }),
    ]
  : bf.i(global.t?.d_viewDefs.class, ['c10v2b']) ? // 追加処理が必要
    [
      cr.myCB_call_tree({
        ctr: 'iud',
        state: 'sdld_c10rDtlsss',
//        b_vsn: true,
        b_vsn: false,
        dd_elmDefss: {
          c10r: {
            elm: 'c10r', // elm混在に注意
            b_setPageKey: true,
            od_insDats: pd => {
              let _d = {
                c10rc11s: pd.c10r.d_flds.c10rc11s ?? '',
                c10rc31s: pd.c10r.d_flds.c10rc31s ?? '',
                c10rc01s: pd.c10r.d_flds.c10rc01s ?? '',
                c10rc02s: pd.c10r.d_flds.c10rc02s ?? '',
                c10rt11i: pd.c10r.d_flds.c10rt11i ?? 10, // c10v1a・c10v2b 固有
              };
              return _d;
            },
          },
        },
      }),
    ]
  : null
;

_op_updc10rc11s = (pd={
  i15rc31s: null,
}) => new Promise( _o_end1 => {
  let _d_c10rs = global.t?.state.sdld_c10rDtlsss.c10r[0];
  cf.myRN_setDat('sdld_c10rDtlsss', _d_c10rs, _d_c10rs => {
    let _d = {
      c10rc11s: `${_d_c10rs.d_flds.i15rc31s} - ${_d_c10rs.d_flds.c100c12s}`,
    };
    return _d;
  })
  .then(() => {
    _o_end1();
  });
});

render() {
  return (
    ce.c(ce.RootDtl, 

    /* ----------------------------------------------------------------------------------------------------
    スタッフ用スタッフ画面
    ---------------------------------------------------------------------------------------------------- */
    (global.t?.d_viewDefs.class == 'c10v1a') ?
      {
        key: -1,
        d_hdrs: {
          pfx: 
//              'スタッフ'
            (global.t?.d_viewDefs.class == 'c10v1a' && global.t?.state.sgc_pnlMode == 'list') ?
              'スタッフ一覧・ログイン情報登録'
            : (global.t?.d_viewDefs.class == 'c10v1a' && global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'show') ?
              'スタッフ・ログイン情報詳細'
            : (global.t?.d_viewDefs.class == 'c10v1a' && global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'edit') ?
              'スタッフ・ログイン情報詳細'
            : (global.t?.d_viewDefs.class == 'c10v1a' && global.t?.state.sgc_pnlMode == 'dtl' && global.t?.state.sgc_pageMode == 'new') ?
              'スタッフ・ログイン情報新規登録'
            : (global.t?.d_viewDefs.class == 'c10v2b') ?
              '設定'
            : null,
          d_subs: 
            ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) == false ?
              {
                iconName: 'users',
                pfx: 'ユーザ切替',
                o_onPrs: () => {
                  let _d_pageInfs = {
                    sgc_pageRole: global.t?.state.sgc_pageRole,
                    sgc_pageName: 'c00v2a',
                    sgc_pageMode: 'show',
                  };
                  cf.myRN_move_fwd(_d_pageInfs);
                },
              }
            : null,
        },
        d_bdys: {
          l_clds: [

            ce.c(ce.Pnl, {
              key: -1,
              mode: 'list',
              b_vsb: (global.t?.state.sgc_pnlMode == 'list') ? true : false,
              d_bdys: {
                d_msgBfrs: {
                  pfx: `【スタッフ・ログイン情報確認・変更】･･･IDを押すと詳細画面に移動し、変更もその画面で行えます。`,
                  n_mgnTop: ic.s(1),
                  d_stlCtas: {
                    minWidth: ic.gn_bdyW,
                  },
                },
                l_clds: [

                ce.c(ce.Box, {
                  key: -10,
                  n_mgnTop: ic.s(1),
                }, [
                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_c10rListsss',
                    dd_elmDefss: {
                      c10r: {
                        b_row: true,
                        b_ttl: false,
                        b_rootHdr: true,
                        d_stlHdrRows: {
                          height: ic.s(1.8),
                        },
                        d_stlBdyRows: {
                          height: ic.s(2.2),
                          marginTop: ic.s(0.2)
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c10rc11s', {
                            b_key: true,
                            d_hdrs: { n_w: ic.s(6)  },
                            d_bdys: { n_w: ic.s(6) },
                          }), // 利用者ID
                          cf.f('c10rc31s', {
                            d_hdrs: { n_w: ic.s(16)  },
                            d_bdys: { n_w: ic.s(16) },
                          }), // 利用者本名
                        ]),
                      },
                    },
                  }),
                ])

                ],
              },
              d_btms: {
/*
                d_news: {
                  elm: 'c10r',
                  state: 'sdld_c10rDtlsss',
                  d_insFlds: {
                    ...cf.e('i10r').d_insFlds, 
                  },
                },
*/
                l_clds: [
                  ce.c(ce.Box, {
                    key: -2,
                    stlCta: {
                      minHeight: ic.s(2 * 2),
                      width: ic.gn_minBdyW,
                      flexDirection: 'row',
                      justifyContent: 'space-around',
                      alignItems: 'center',
                      marginTop: ic.s(0.5), // 20211202
                      marginBottom: ic.s(0.5), // 20211202
                      marginLeft: 'auto',
                      marginRight: 'auto',
                    }
                  }, [
                    ce.c(ce.Btn, {
                      key: -20,
                      pfx: '前の画面に戻る',
                      stlBtn: {
                        width: ic.s(8),
                        backgroundColor: ic.g_ccdHN,
                        borderColor: ic.g_ccdHN,
                      },
                      o_onPrs: () => {
                        let _d_pageInfs = {
                          sgc_pageRole: global.t?.state.sgc_pageRole,
                          sgc_pageName: 'iStg1',
                          sgc_pageMode: 'show',
                        }; 
                        cf.myRN_move_fwd(_d_pageInfs);
                      },
                    }),
                    ce.c(ce.Btn, {
                      key: -10,
                      pfx: 'スタッフの新規登録',
                      b_rvs: false,
                      stlBtn: {
                        width: ic.s(12),
                      },
                      o_onPrs: () => {
                        cf.myRN_chgPageMode({
                          elm: 'c10r',
                          state: 'sdld_c10rDtlsss',
                          d_insFlds: {
                            ...cf.e('i10r').d_insFlds, 
                          },
                          mode: 'sttNew',
                          b_clr: true, // 現行要素の初期化に必要
                        })
                      },
                    }),
                  ])
                ],
              },
            }),

            ce.c(ce.Pnl, {
              key: -2,
              mode: 'dtl',
              b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
              d_hdrs: {
                d_htys: 
                  (global.t?.d_viewDefs.class == 'c10v1a') ?
                    {
                      elm: 'c10r',
                      ld_iss: global.t?.state.sdld_c10rVsnListsss?.c10r,
                      op_loadDtl: c10v.op_loadDtl,
                    }
                  : (global.t?.d_viewDefs.class == 'c10v2b') ?
                    null
                  : null
                ,
              },
              d_bdys: {
                l_clds: [

                  ce.c(ce.Box, {
                    key: -10,
                    n_mgnTop: ic.s(1),
                  }, [

                    ce.c(cr.InpTree, {
                      key: -1,
                      state: 'sdld_c10rDtlsss',
                      b_vsb: true,
                      b_edit: true,
                      dd_elmDefss: {
                        c10r: {
                          d_cmns: {
                            n_cnt: 1,
                          },
                          dd_fldDefss: cf.myRN_getFldDefs(
                            (global.t?.d_viewDefs.class == 'c10v1a') ?
                              [
                                cf.f('c10rc11s', {
                                  d_hdrs: { n_w: ic.s(6)  },
                                  d_bdys: { n_w: ic.s(16) },
                                }), // 利用者ID
                                cf.f('c10rc31s', {
                                  d_hdrs: { n_w: ic.s(6)  },
                                  d_bdys: { n_w: ic.s(16) },
                                }), // 利用者本名
                                cf.f('c10rc01s', {
                                  d_hdrs: { n_w: ic.s(6)  },
                                  d_bdys: { n_w: ic.s(16) },
                                }), // 利用者本名
                                cf.f('c10rc02s', {
//                                  b_pwd: true,
                                  b_pwd: ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? false : true,
/*
                                  o_stlVal: _d_dats => {
//                                    return ff.myCM_pdd('', ff.myCM_getLen(_d_dats.d_flds.c10rc02s), '●')
                                    return ff.myCM_pdd('', ff.myCM_getLen(_d_dats.d_flds.c10rc02s)-1, '●') + String(_d_dats.d_flds.c10rc02s).substr(ff.myCM_getLen(_d_dats.d_flds.c10rc02s)-1,1)
                                  },
*/
                                  o_stlVal: _d_dats => {
                                    return ff.myCM_pdd('', ff.myCM_getLen(_d_dats.d_flds.c10rc02s), '●')
                                  },
                                  d_hdrs: { n_w: ic.s(6)  },
                                  d_bdys: { n_w: ic.s(16) },
                                }), // 利用者本名
                              ]
                            : (global.t?.d_viewDefs.class == 'c10v2b') ?
                              [
                                cf.f('c10rc01s', {
                                }), // 利用者本名
                                cf.f('c10rc02s', {
//                                  b_pwd: true,
                                  b_pwd: ff.i(global.t?.state.sgc_pageMode, ['new', 'edit']) ? false : true,
                                  o_stlVal: _d_dats => {
                                    return ff.myCM_pdd('', ff.myCM_getLen(_d_dats.d_flds.c10rc02s), '●')
                                  }
                                }), // 利用者本名
                              ]
                            : []
                          ),
                        },
                      },
                    }),
                  ])

                ],
              },
              d_btms: {
              },
            }),

          ],
        }
      }

    /* ----------------------------------------------------------------------------------------------------
    団体用設定画面
    ---------------------------------------------------------------------------------------------------- */
    : (global.t?.d_viewDefs.class == 'c10v2b') ?
      {
        key: -1,
        d_hdrs: {
          pfx: '設定',
        },
        d_bdys: {
          l_clds: [
            ce.c(ce.Pnl, {
              key: -2,
              mode: 'dtl',
              b_vsb: (global.t?.state.sgc_pnlMode == 'dtl') ? true : false,
              d_hdrs: {
                d_htys: null,
              },
              d_bdys: {
                l_clds: [
                  ce.c(cr.InpTree, {
                    key: -1,
                    state: 'sdld_c10rDtlsss',
                    b_vsb: true,
                    b_edit: true,
                    dd_elmDefss: {
                      c10r: {
                        d_cmns: {
                          n_cnt: 1,
                        },
                        dd_fldDefss: cf.myRN_getFldDefs([
                          cf.f('c10ri11s', {
                            d_hdrs: { n_w: ic.s(10) },
                            d_bdys: { n_w: ic.s(20) },
                          }), // メールアドレス
                        ]),
                      },
                    },
                  }),
                ],
              },
              d_btms: {
                b_rtn: false,
              },
            }),

          ],
        }
      }

    : null

    )
  );
}

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
